import { Button, Flex, IconButton, Link, Text } from "@chakra-ui/react";
import clsx from "clsx";
import { differenceInDays, parseISO } from "date-fns";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import { MdsCalendarTodayRound } from "react-icons-with-materialsymbols/mds";
import { useSelector } from "react-redux";

import { Icon } from "@/design/components/icon";
import { currentUserMetadata } from "@/slices/auth-slice";
import { AnalyticsEvents } from "@/utils/analytics-events";
import { analyticsService } from "@/utils/analytics-service";

export const TrialExpirationBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const userMetadata = useSelector(currentUserMetadata);

  const isNotTrialUser = !userMetadata?.isTrialUser || !userMetadata?.trialUserExpiryDate;
  if (isNotTrialUser || !isVisible) return null;

  const daysLeft = differenceInDays(
    parseISO(userMetadata.trialUserExpiryDate as string),
    new Date()
  );

  if (daysLeft < 0) return null;

  return (
    <Flex
      className={clsx(
        "px-4 py-2 text-sm font-medium text-center relative items-center justify-start",
        "text-yellow-800 bg-yellow-50 border border-yellow-300"
      )}
      id="trial-expiration-banner"
    >
      <Icon as={MdsCalendarTodayRound} size="sm" className="mr-1" />
      <Text>
        Your trial expires in {daysLeft} {daysLeft === 1 ? "day" : "days"}.{" "}
        <Link
          className="text-yellow-800 !underline"
          as="span"
          onClick={() => {
            analyticsService.trackEvent(AnalyticsEvents.CONTACT_US.BANNER);
            window.open(
              "https://clootrack.com/request-demo",
              "_blank",
              "noopener,noreferrer"
            );
          }}
        >
          Contact us
        </Link>
      </Text>
      <IconButton
        className="hover:bg-yellow-100"
        pos="absolute"
        top="50%"
        right="2"
        transform="translateY(-50%)"
        aria-label="Close trial expiration banner"
        colorScheme="secondary"
        icon={<MdClose />}
        onClick={() => setIsVisible(false)}
        size="xs"
        variant="ghost"
      />
    </Flex>
  );
};
